import { useCallback } from "react";
import { createSearchParams, useNavigate } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import LanguageSelectForm from "components/molecules/LanguageSelectForm";
import { useGTM } from "hooks/useGTM";
import { useBreakpoint } from "hooks/useBreakpoint";
import { useLanguage } from "hooks/useLanguage";
import { makeLangUrl } from "helpers/makeLangUrl";
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";
import { useCatalogsStore } from "stores/catalogs";
import { useLocalizationStore } from "stores/localization";

const LanguageSelectFormContainer = () => {
  const GTM = useGTM();
  const languages = useCatalogsStore((state) => state.languages);
  const { language, changeLanguage } = useLocalizationStore((state) => ({
    language: state.language,
    changeLanguage: state.changeLanguage,
    initLanguage: state.initLanguage,
  }));
  const { isDesktop } = useBreakpoint();
  const navigate = useNavigate();
  const { path } = useLanguage();
  const methods = useForm();

  const handleLanguageChange = useCallback(
    (name: string) => {
      GTM.clickChangeLanguage(name);
      changeLanguage(name); // Обновляем Zustand и i18next
      // Обновляем URL
      navigate(
        {
          pathname: makeLangUrl(path, name), // Добавляем язык в URL, если нужно
          ...(!isDesktop && {
            search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.sideMenu })}`,
          }),
        },
        { replace: true },
      );
    },
    [GTM, navigate, path, isDesktop, changeLanguage],
  );

  if (!languages) {
    return null;
  }

  return (
    <FormProvider {...methods}>
      <LanguageSelectForm
        languages={languages}
        selectedLanguage={language || "en"}
        onChange={handleLanguageChange}
      />
    </FormProvider>
  );
};

export default LanguageSelectFormContainer;
